import {
  GET_TELECONSULT_SUCCESS,
  GET_TELECONSULT_FAIL,
  GET_TELECONSULT_DETAILS_SUCCESS,
  GET_TELECONSULT_DETAILS_FAIL,
  ADD_TELECONSULT_SUCCESS,
  ADD_TELECONSULT_FAIL,
  UPDATE_TELECONSULT_SUCCESS,
  UPDATE_TELECONSULT_FAIL,
  DELETE_TELECONSULT_SUCCESS,
  DELETE_TELECONSULT_FAIL,
  CONFIRM_TELECONSULT_SUCCESS,
  CONFIRM_TELECONSULT_FAIL,
  COMPLETE_TELECONSULT_SUCCESS,
  COMPLETE_TELECONSULT_FAIL,
  ADD_REMARKS_TELE_APPOINTMENTS_SUCCESS,
  ADD_REMARKS_TELE_APPOINTMENTS_FAIL,
  RESET_TELECONSULT_STATE,
} from "./actionTypes"

const INIT_STATE = {
  teleconsult: [],
  teleconsultDetails: [],
  addTeleconsult: [],
  editTeleconsult: [],
  delTeleconsult: [],
  confirmTeleconsult: [],
  completeTeleconsult: [],
  addRemarksTeleAppointments: [],
}

const Teleconsult = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TELECONSULT_SUCCESS:
      return {
        ...state,
        teleconsult: action.payload,
      }

    case GET_TELECONSULT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_TELECONSULT_DETAILS_SUCCESS:
      return {
        ...state,
        teleconsultDetails: action.payload,
      }

    case GET_TELECONSULT_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
        teleconsultDetails: action.payload
      }

    case ADD_TELECONSULT_SUCCESS:
      return {
        ...state,
        teleconsultDetails: action.payload.data,
        addTeleconsult: action.payload,
      }

    case ADD_TELECONSULT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_TELECONSULT_SUCCESS:
      return {
        ...state,
        teleconsultDetails: action.payload.data,
        editTeleconsult: action.payload,
      }

    case UPDATE_TELECONSULT_FAIL:
      return {
        ...state,
        error: action.payload,
        editTeleconsult: action.payload,
      }
    case DELETE_TELECONSULT_SUCCESS:
      return {
        ...state,
        delTeleconsult: action.payload,
      }

    case DELETE_TELECONSULT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CONFIRM_TELECONSULT_SUCCESS:
      return {
        ...state,
        confirmTeleconsult: action.payload,
      }

    case CONFIRM_TELECONSULT_FAIL:
      return {
        ...state,
        error: action.payload,
        confirmTeleconsult: action.payload,
      }
    //complete
    case COMPLETE_TELECONSULT_SUCCESS:
      return {
        ...state,
        completeTeleconsult: action.payload,
      }

    case COMPLETE_TELECONSULT_FAIL:
      return {
        ...state,
        error: action.payload,
        completeTeleconsult: action.payload,
      }
    //remarks
    case ADD_REMARKS_TELE_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        addRemarksTeleAppointments: action.payload,
      }

    case ADD_REMARKS_TELE_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        addRemarksTeleAppointments: action.payload,
      }
    case RESET_TELECONSULT_STATE:
      return {
        ...state,
        addTeleconsult: [],
        editTeleconsult: [],
        delTeleconsult: [],
        confirmTeleconsult: [],
        completeTeleconsult: [],
        addRemarksTeleAppointments: [],
        teleconsultDetails: [],
        error: [],
      }
    default:
      return state
  }
}

export default Teleconsult
